export const gstList = [
  { id: 0, name: 'All GST Types' },
  { id: 1, name: 'FCM' },
  { id: 2, name: 'RCM' },
];

export const filters = {
  STATUS: 'Status',
  GST_TYPE: 'GST Type',
};

export const statusList = [
  { id: 0, name: 'All Statuses' },
  { id: 1, name: 'Active' },
  { id: 2, name: 'Inactive' },
];

export const maxDisplayColumn = 7;

export const msmeOptions = [
  { id: 1, name: 'YES' },
  { id: 0, name: 'NO' },
];
